<template>
  <div class="breadcrumb flex items-center py-3">
    当前位置：<el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <template v-for="router in routerMatchedList">
        <!-- 满足完整面包屑路径 -->
        <template v-if="router.meta.breadcrumb">
          <el-breadcrumb-item
            v-for="prevRouter in router.meta.breadcrumb"
            :key="prevRouter.name"
            :to="{ name: prevRouter.name }"
            >{{ prevRouter.title }}</el-breadcrumb-item
          >
        </template>
        <el-breadcrumb-item
          v-if="router.meta.title == '数据库'"
          :key="router.name"
          :to="{ path: '/data/produce' }"
          >{{ router.meta.title }}</el-breadcrumb-item
        >
        <el-breadcrumb-item
          v-else
          :key="router.name"
          :to="{ name: router.name }"
          >{{ router.meta.title }}</el-breadcrumb-item
        >
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
import { Breadcrumb, BreadcrumbItem } from "element-ui";

export default {
  name: "MyBreadcrumb",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
  },
  computed: {
    routerMatchedList: function () {
      return this.$route.matched;
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  font-weight: 400;
  .el-breadcrumb__item {
    font-size: 16px;
    color: #6c6c6c;

    &:last-child {
      ::v-deep  .el-breadcrumb__inner {
        color: rgba(50, 128, 75, 1);
      }
    }
  }
  ::v-deep  .el-breadcrumb__inner.is-link {
    font-weight: normal;
    color: #6c6c6c;
    &:hover {
      color: rgba(50, 128, 75, 1);
    }
  }
}
</style>
